import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/hourglass.svg'


const _withScopeId = n => (_pushScopeId("data-v-372cae1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 3 }
const _hoisted_2 = { key: 4 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "campaign-i" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createTextVNode(" Campaign is Still In Progress ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "results-campaign" }, "Results will be shown after the Campaign is completed", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request-license" }, "REQUEST LICENSE", -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "p-d-flex p-flex-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Warning", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-4 p-mb-6" }, "Not enough money in your wallet, please top up your wallet and try again.", -1))
const _hoisted_10 = { class: "p-d-flex p-justify-center buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LatestContentItem = _resolveComponent("LatestContentItem")!
  const _component_ContentRequestModal = _resolveComponent("ContentRequestModal")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItems.sort((a, b) => b.statistics.viewCount - a.statistics.viewCount), (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: `${index}_live`,
      class: "p-mt-4 p-d-flex p-flex-column p-ai-center"
    }, [
      _createElementVNode("div", null, [
        _createVNode(_component_LatestContentItem, { item: item }, null, 8, ["item"]),
        (_ctx.campaignClosed && !item?.delete)
          ? (_openBlock(), _createBlock(_component_ContentRequestModal, {
              key: 0,
              show: _ctx.showContentModal,
              item: _ctx.requestItem,
              "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showContentModal = false)),
              onLicenseRequest: _ctx.licenseRequest
            }, null, 8, ["show", "item", "onLicenseRequest"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.campaignClosed && !item?.delete && !_ctx.isItemBuy(item)?.accepted && !_ctx.isItemBuy(item)?.pending)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            disabled: _ctx.findStatus(item) === 'pending',
            class: "continue-button",
            onClick: ($event: any) => {_ctx.showContentModal=true; _ctx.requestItem = item},
            style: {"margin-top":"50px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("REQUEST LICENSE ")
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.campaignClosed && !item?.delete && _ctx.isItemBuy(item)?.accepted && !_ctx.isItemBuy(item)?.pending)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            class: "continue-button",
            style: {"margin-top":"50px"},
            disabled: _ctx.campaignClosed && !item?.delete && _ctx.isItemBuy(item)?.accepted
          }, {
            default: _withCtx(() => [
              _createTextVNode("purchased on " + _toDisplayString(_ctx.formatDate(_ctx.isItemBuy(item)?.startDate)), 1)
            ]),
            _: 2
          }, 1032, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.campaignClosed && !item?.delete && _ctx.isItemBuy(item)?.pending)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 2,
            class: "continue-button",
            style: {"margin-top":"50px"},
            disabled: true
          }, {
            default: _withCtx(() => [
              _createTextVNode("requested " + _toDisplayString(_ctx.formatDate(_ctx.isItemBuy(item)?.startDate)), 1)
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true),
      (item?.delete)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_1, "Influencer left the company"))
        : _createCommentVNode("", true),
      (!_ctx.campaignClosed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
        : _createCommentVNode("", true),
      _createVNode(_component_Dialog, {
        visible: _ctx.showNeedPayModal,
        class: "p-col-12 p-md-6 p-xl-4 gi-dialog",
        modal: true,
        closable: false,
        style: { width: '550px' , height : '280px' },
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:show', false)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("section", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Button, {
                class: "red-button p-d-flex p-justify-center",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showNeedPayModal = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("OK")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]))
  }), 128))
}